import React, { useState } from 'react'
import { numberFormat } from '../../../helpers/numberFormat'
import { numberToDateString } from '../../../helpers/numberToDateString'
import axios from '../../../lib/axios'
import { MySwal } from '../../../lib/swal'

const RiwayatTransaksiDetailPesertaComp = (props) => {

    const [disabled, setdisabled] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [urutan, setUrutan] = useState('')
    const [urutanDetail, setUrutanDetail] = useState('')
    const [participantId, setparticipantId] = useState({})
    const [fullname, setFullname] = useState('')

    const [email, setEmail] = useState('')
    const [mobilePhone, setmobilePhone] = useState('')


    const handleEditParticipant = (index, idx, p) => {
        setisEdit(true)
        setUrutan(index)
        setUrutanDetail(idx)
        setparticipantId(p.id)
        setEmail(p.email)
        setmobilePhone(p.mobilePhone)
        setFullname(p.firstName.concat(' ').concat(p.lastName))
    }

    const handleCancelEdit = () => {
        setisEdit(false)
        setUrutan('')
        setUrutanDetail('')
        setparticipantId('')
        setEmail('')
        setmobilePhone('')
        setFullname('')
    }

    const handlePatchParticipant = () => {
        setdisabled(true)
        const config = {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            }
        }

        let splitFullname = fullname.split(/[ ,]+/)

        const requestBody = {
            firstName: splitFullname[0],
            lastName: splitFullname[1] === undefined ? splitFullname[0] : splitFullname[1],
            email: email,
            mobilePhone: mobilePhone
        }

        // console.log(requestBody)
        // return false

        axios.patch(`users/participants/${participantId}`, requestBody, config)
            .then(res => {

                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Update Participant Successfully!',
                    })
                    // return false
                    setdisabled(false)
                    handleCancelEdit()
                    props.close()
                    props.fetch()

                }
            })
            .catch(err => {
                if (err !== "") {
                    console.log(err?.response?.data)
                    MySwal.fire({
                        icon: 'info',
                        title: 'Info',
                        text: `${err?.response?.data?.message}`,
                    })
                }
                setdisabled(false)
            });
    }

    return (
        <>
            {
                props.transactionItems.map((row, index) => (
                    <>
                        <div key={index} className='row d-flex justify-content-between'>
                            <div className='col'>
                                <label style={{ color: '#808B96' }}>Nama Program</label>
                                <p style={{ fontWeight: '600', color: '#191919' }}>{row.Schedule.Program.name}</p>
                            </div>
                            <div className='col'>
                                <label style={{ color: '#808B96' }}>Jadwal Program</label>
                                <p style={{ fontWeight: '600', color: '#191919' }}>
                                    {numberToDateString(row.Schedule.startDate)} s/d {numberToDateString(row.Schedule.endDate)}
                                </p>
                            </div>
                            <div className='col'>
                                <label style={{ color: '#808B96' }}>Harga</label>
                                <p style={{ fontWeight: '600', color: '#0C86D9', fontSize: '16px' }}>
                                    {numberFormat(row.price)}
                                </p>
                            </div>
                        </div>
                        <hr></hr>
                        <div key={index} className='row mb-4'>
                            <h3 className='mb-3'>Daftar Peserta</h3>
                            <div className="card" style={{
                                backgroundColor: '#F2F2F2',
                            }}>
                                <div className="card-body">
                                    <div className='table-responsive'>
                                        <table className='table mb-3'>
                                            <thead>
                                                <tr>
                                                    <th>Nama Lengkap</th>
                                                    <th>Email</th>
                                                    <th>No Telepon</th>
                                                    <th>Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    isEdit === true &&
                                                        urutan === index ?
                                                        <tr>
                                                            <td>
                                                                <input type='text' className='form-control' placeholder='Nama Lengkap' value={fullname} onChange={(e) => setFullname(e.target.value)} disabled={disabled} />
                                                            </td>
                                                            <td>
                                                                <input type='email' className='form-control' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} disabled={disabled} />
                                                            </td>
                                                            <td>
                                                                <input type='text' className='form-control' placeholder='Nomor Handphone' value={mobilePhone} onChange={(e) => setmobilePhone(e.target.value)} disabled={disabled} />
                                                            </td>
                                                            <td>
                                                                <button className='btn' style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }} onClick={() => handlePatchParticipant()} disabled={disabled}>
                                                                    Simpan
                                                                </button>
                                                                &nbsp;
                                                                <button className='btn' style={{ backgroundColor: '#191919', color: '#F2F2F2' }} onClick={() => handleCancelEdit()}>
                                                                    Batal
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        :
                                                        ''
                                                }
                                                {
                                                    row.Participants.map((p, idx) => (
                                                        urutan === index &&
                                                            urutanDetail === idx ?
                                                            ''
                                                            :
                                                            <tr key={idx}>
                                                                <td>{p.firstName}&nbsp;{p.lastName}</td>
                                                                <td>{p.email}</td>
                                                                <td>{p.mobilePhone}</td>
                                                                <td>
                                                                    <button className='btn btn-primary' onClick={() => handleEditParticipant(index, idx, p)}>
                                                                        Edit
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ))
            }
        </>
    )
}

export default RiwayatTransaksiDetailPesertaComp
